<template>
  <div>
    <section>
      <div class="container-fluid">
        <div class="title_farm">
          <h1>
            {{ translate("menu2.manage_coffee_score") }}
          </h1>
          <div class="btn farm-name">
            <i class="fas fa-map-marker-alt pr-2"></i>
            {{ `${this.translate("menu.in")} ${dataFarm.name}` }}
          </div>
        </div>
        <div class="con_title mb-2">
          <div class="con_title_back">
            <div
              class="back_befor_page"
              onclick="window.history.go(-1); return false;"
            >
              <i class="fas fa-arrow-alt-circle-left"></i>
              <div class="text">{{ translate("menu.back") }}</div>
            </div>
          </div>
          <div class="con_title_search">
            <div class="card-tools">
              <div class="input-group input-group-sm">
                <div class="input-group">
                  <button
                    @click.prevent="clearSearch()"
                    class="btn btn-primary"
                    v-if="isInputSearch"
                  >
                    <i class="fas fa-undo"></i>
                  </button>
                  <input
                    type="text"
                    name="table_search"
                    class="form-control"
                    aria-label="Sizing example input"
                    aria-describedby="inputGroup-sizing-default"
                    :placeholder="translate('menu.search')"
                    v-model="filter.search"
                    v-on:keyup.enter="searchKey()"
                  />

                  <button
                    type="button"
                    @click="searchKey()"
                    class="btn btn-primary"
                  >
                    <i class="fas fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </section>
    <section class="content">
      <div class="container-fluid">
        <!-- /.row -->
        <div class="row">
          <div class="col-12">
            <div class="card">
              <div class="card-header">
                <div class="d-flex">
                  <div class="mr-auto change_list">
                    <div class="dropdown">
                      <button
                        class="btn btn-default tb_row_drop dropdown-toggle"
                        type="button"
                        id="showRow"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <span class="tb_row_text"
                          >{{ translate("menu2.show") }} {{ filter.listNum }}
                          {{ translate("menu2.row") }}</span
                        >
                        <span class="icon-caret drop_caret"></span>
                      </button>
                      <div
                        class="
                          dropdown-menu
                          dropdown-menu-right
                          dropdown-menu-lg-left
                          show_list_dropdown
                        "
                        aria-labelledby="showRow"
                      >
                        <a class="dropdown-item" @click="changeList(5)">5</a>
                        <a class="dropdown-item" @click="changeList(10)">10</a>
                        <a class="dropdown-item" @click="changeList(50)">50</a>
                        <a class="dropdown-item" @click="changeList(100)"
                          >100</a
                        >
                        <a class="dropdown-item" @click="changeList(200)"
                          >200</a
                        >
                        <a class="dropdown-item" @click="changeList(1000)"
                          >1000</a
                        >
                      </div>
                    </div>
                  </div>

                  <div class="title">
                    <button
                      class="btn btn-loc"
                      @click="openModal()"
                      v-if="$permission.isCreateUser()"
                    >
                      <i class="fas fa-plus"></i>
                      {{ translate("menu2.add") }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table
                    class="
                      table table-bordered table-hover table-striped
                      sortTable
                    "
                  >
                    <thead>
                      <tr>
                        <th
                          class="text-uppercase"
                          width="5%"
                          :class="$sortedClass('order')"
                          @click="$sortBy('order')"
                        >
                          {{ translate("menu2.order") }}
                        </th>
                        <th
                          :class="$sortedClass('before_pic')"
                          @click="$sortBy('before_pic')"
                        >
                          {{ translate("menu2.before_pic") }}
                        </th>
                        <th
                          :class="$sortedClass('after_pic')"
                          @click="$sortBy('after_pic')"
                        >
                          {{ translate("menu2.after_pic") }}
                        </th>
                        <th
                          :class="$sortedClass('cup_score')"
                          @click="$sortBy('cup_score')"
                        >
                          {{ translate("menu2.cup_score") }}
                        </th>
                        <th
                          :class="$sortedClass('charact')"
                          @click="$sortBy('charact')"
                        >
                          {{ translate("menu2.charact") }}
                        </th>
                        <th
                          :class="$sortedClass('scored_date')"
                          @click="$sortBy('scored_date')"
                        >
                          {{ translate("menu2.scored_date") }}
                        </th>

                        <th
                          width="8%"
                          class="text-uppercase"
                          v-if="
                            $permission.isEditUser() ||
                            $permission.isDeleteUser()
                          "
                        >
                          {{ translate("menu.edit") }}/{{
                            translate("menu.delete")
                          }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(data, index) in sortedItems" :key="index">
                        <td>
                          {{ data.order }}
                        </td>
                        <td>
                          <div class="overflow_hide_img">
                            <img
                              class="overflow_hide_img_spot"
                              @error="replaceLink($event)"
                              :src="
                                data.before_pic == ''
                                  ? `/img/error_img.png`
                                  : `/img/score/${data.before_pic}`
                              "
                            />
                          </div>
                        </td>
                        <td>
                          <div class="overflow_hide_img">
                            <img
                              class="overflow_hide_img_spot"
                              @error="replaceLink($event)"
                              :src="
                                data.after_pic == ''
                                  ? `/img/error_img.png`
                                  : `/img/score/${data.after_pic}`
                              "
                            />
                          </div>
                        </td>
                        <td>
                          {{ data.cup_score }}
                        </td>
                        <td>
                          <div class="truncate">
                            {{ data.charact }}
                          </div>
                        </td>
                        <td>
                          <div class="link_to">
                            <!-- <div> -->
                            <span class="view_val">{{
                              formatDate(data.scored_date)
                            }}</span>
                          </div>
                        </td>
                        <td
                          style="display: flex"
                          v-if="
                            $permission.isEditMasterData() ||
                            $permission.isDeleteMasterData()
                          "
                        >
                          <button
                            class="btn btn-action"
                            @click="toEditModal(data)"
                            v-if="$permission.isEditMasterData()"
                          >
                            <i class="fas fa-edit btn-edit"></i>
                          </button>
                          <button
                            class="btn btn-action"
                            @click="openModalScore(data)"
                            v-if="$permission.isEditMasterData()"
                          >
                            <i class="fas fa-eye btn-edit"></i>
                          </button>
                          <button
                            class="btn btn-action"
                            @click="toDelete(data.id)"
                            v-if="$permission.isDeleteMasterData()"
                          >
                            <i class="fas fa-trash-alt btn-delete"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                <!-- pagination -->
                <div class="row">
                  <div class="col-md-8">
                    <nav>
                      <ul class="pagination">
                        <li
                          class="page-item"
                          :class="{ disabled: !pagination.first_link }"
                        >
                          <a
                            href="#"
                            @click="getData(pagination.first_link)"
                            class="page-link"
                          >
                            <span aria-hidden="true">&laquo;</span>
                          </a>
                        </li>
                        <li
                          class="page-item"
                          :class="{ disabled: !pagination.prev_link }"
                        >
                          <a
                            href="#"
                            @click="getData(pagination.prev_link)"
                            class="page-link"
                          >
                            <span aria-hidden="true">&#8249;</span>
                          </a>
                        </li>
                        <template
                          v-for="(pageNumber, index) in pagination.last_page"
                        >
                          <li
                            :key="index"
                            v-if="
                              Math.abs(pageNumber - pagination.current_page) <
                                3 ||
                              pageNumber === pagination.last_page ||
                              pageNumber == 1
                            "
                            class="page-item"
                            :class="{
                              active: pagination.current_page == pageNumber,
                            }"
                          >
                            <a
                              href="#"
                              @click="
                                getData(pagination.path_page + pageNumber)
                              "
                              class="page-link pagi_link"
                              :class="{
                                last:
                                  pageNumber == pagination.last_page &&
                                  Math.abs(
                                    pageNumber - pagination.current_page
                                  ) > 3,
                                first:
                                  pageNumber == 1 &&
                                  Math.abs(
                                    pageNumber - pagination.current_page
                                  ) > 3,
                              }"
                              >{{ pageNumber }}</a
                            >
                          </li>
                        </template>

                        <li
                          class="page-item"
                          :class="{ disabled: !pagination.next_link }"
                        >
                          <a
                            href="#"
                            @click="getData(pagination.next_link)"
                            class="page-link"
                          >
                            <span aria-hidden="true">&#8250;</span>
                          </a>
                        </li>
                        <li
                          class="page-item"
                          :class="{ disabled: !pagination.last_link }"
                        >
                          <a
                            href="#"
                            @click="getData(pagination.last_link)"
                            class="page-link"
                          >
                            <span aria-hidden="true">&raquo;</span>
                          </a>
                        </li>
                      </ul>
                    </nav>
                  </div>
                  <div class="col-md-4 d-flex justify-content-end">
                    <div>
                      {{ translate("menu2.page") }}:
                      {{ pagination.from_page }} - {{ pagination.to_page }}
                      {{ translate("menu2.total") }}:
                      {{ pagination.total_page }}
                    </div>
                  </div>
                </div>
                <!-- pagination -->
              </div>
            </div>
            <!-- /.card -->
          </div>
        </div>
      </div>
      <!-- /.container-fluid -->
    </section>
    <EvaluationModal ref="EvaluationModal" @openAddScore="openModalScore" />
    <ScoreModal ref="ScoreModal" />
  </div>
</template>
<script>
import EvaluationModal from "./EvaluationModal";
import ScoreModal from "./ScoreModal";
import moment from "moment";
import { mapGetters, mapActions } from "vuex";

export default {
  components: { EvaluationModal, ScoreModal },
  data() {
    return {
      api_url: "/api/evaluations/",
      pagination: {},
      pagi: "",
      filter: {
        pagiurl: "",

        listNum: "",
        search: "",
      },
      form: {
        id: "",
        status: "",
      },
      isInputSearch: false,
      sort: {
        key: "",
        isAsc: false,
      },
      dataFarm: {
        name: "",
        id: "",
      },
    };
  },
  mounted() {
    this.setDataUrl();

    Fire.$on("updateData", () => {
      this.getData(this.api_url);
    });

    this.getScoreCategories();
    // .then((res) => {
    // });
  },
  watch: {
    filter: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val.search) {
          this.isInputSearch = true;
        } else {
          this.isInputSearch = false;
        }
      },
    },
  },

  computed: {
    ...mapGetters(["evaluations"]),
    sortedItems() {
      const list = this.evaluations.slice();
      for (let i = 0; i < list.length; i++) {
        list[i].order = this.$getOverallIndex(i, this.pagination);
      }
      if (!!this.sort.key) {
        list.sort((a, b) => {
          a = a[this.sort.key];
          b = b[this.sort.key];

          return (a === b ? 0 : a > b ? 1 : -1) * (this.sort.isAsc ? 1 : -1);
        });
      }

      return list;
    },
  },

  methods: {
    ...mapActions([
      "fetchProcesses",
      "deleteProcess",
      "getEvaluations",
      "deleteEvaluation",
      "getScoreCategories",
    ]),
    formatDate(date) {
      return moment(date).format("YYYY-MM-DD");
    },
    replaceLink(event) {
      event.target.src = "/img/error_img.png";
    },
    notShowOwner(role_id) {
      let allow = true;
      if (
        (this.$auth_id == this.$gvar.superadmin &&
          role_id == this.$gvar.superadmin) ||
        role_id != this.$gvar.superadmin
      ) {
        allow = true;
      } else {
        allow = false;
      }

      return allow;
    },
    switchStatus(id) {
      let checkedValue = document.getElementById("status_switch" + id);
      let status;
      checkedValue.checked == true ? (status = 1) : (status = 0);

      swal
        .fire({
          title: this.translate("menu2.are_you_sure?"),
          text:
            status == 1
              ? this.translate("menu2.you_want_open")
              : this.translate("menu2.you_want_block"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3490dc",
          cancelButtonColor: "#FF5A5F",
          confirmButtonText: this.translate("menu2.yes"),
          cancelButtonText: this.translate("menu2.cancel"),
          reverseButtons: true,
        })
        .then((result) => {
          if (result.value) {
            this.form.id = id;
            this.form.status = status;
            this.changeUserStatus(this.form)
              .then((response) => {
                swal.fire(
                  response.data.new_data.status == 1
                    ? this.translate("menu2.open")
                    : this.translate("menu2.block"),
                  response.data.message,
                  response.data.success ? "success" : "error"
                );
              })
              .catch((error) => {
                if (error.response) {
                  swal.fire(
                    this.translate("menu2.error"),
                    error.response.data.message,
                    "warning"
                  );
                }
              });
          } else {
            if (checkedValue.value == 1) {
              checkedValue.checked = true;
            } else {
              checkedValue.checked = false;
            }
          }
        });
    },
    updatePermission(user_id) {
      this.$refs.permissionModal.openPermissionModal(user_id);
    },
    openModal() {
      this.$refs.EvaluationModal.openModal();
    },
    openModalScore(data) {
      this.$refs.ScoreModal.openModal(data);
    },
    toEditModal(user) {
      this.$refs.EvaluationModal.openModalEdit(user);
    },

    toDelete(id) {
      swal
        .fire({
          title: this.translate("menu2.are_you_sure?"),
          text: this.translate("menu2.you_wont_get_back"),
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3490dc",
          cancelButtonColor: "#FF5A5F",
          confirmButtonText: this.translate("menu2.yes_delete_it"),
          cancelButtonText: this.translate("menu2.cancel"),
        })
        .then((result) => {
          if (result.value) {
            this.deleteEvaluation(id)
              .then((response) => {
                if (response.data.success) {
                  swal.fire(
                    this.translate("menu2.delete"),
                    response.data.message,
                    "success"
                  );
                } else {
                  swal.fire(
                    this.translate("menu2.error"),
                    response.data.message,
                    "error"
                  );
                }
              })
              .catch((error) => {
                if (error.response) {
                  swal.fire(
                    this.translate("menu2.error"),
                    error.response.data.message,
                    "warning"
                  );
                }
              });
          }
        });
    },

    getData(pagi) {
      this.filter.pagiurl = pagi || this.api_url;
      this.getEvaluations(this.filter)
        .then((response) => {
          this.filter.listNum = response.listNum;
          this.pagination = this.$paginate(response.message);
        })
        .catch((error) => {
          if (error.response) {
            swal.fire(
              this.translate("menu2.error"),
              error.response.data.message,
              "warning"
            );
          }
        });
    },
    getOverallIndex(index) {
      return (
        this.pagination.current_page * this.pagination.per_page -
        this.pagination.per_page +
        index +
        1
      );
    },
    searchKey() {
      this.filter.pagiurl = this.api_url;
      this.getData(this.filter.pagiurl);
    },
    clearSearch() {
      this.filter.search = "";
      this.getData(this.filter.pagiurl);
    },
    changeList(num) {
      this.$cookies.set("location_listnum", num);
      this.filter.listNum = num;
      this.getData(this.filter.pagiurl);
    },
    //End filter
    setDataUrl() {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = Object.fromEntries(urlSearchParams.entries());
      this.dataFarm = params;
      this.api_url = this.api_url + this.dataFarm.id;

      this.filter.listNum = this.$cookies.get("process_listnum");
      this.getData(this.api_url);
    },
  },
};
</script>


<style lang="scss" scoped>
.btn-action {
  background-color: #f0f0f0;
  border-radius: 10px;
  margin: 3px;
  .btn-edit {
    color: green;
  }
  .btn-delete {
    color: red;
  }
}
.title {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: flex-end;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.btn-loc {
  height: 40px;
  text-align: center;
  background: #55b2be;
  box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 20px;
  color: white;
  font-size: 16px;

  & i {
    margin-right: 9px;
    font-size: 20px;
  }
}

img {
  max-width: 200px;
  max-height: 200px;
}
.back_befor_page {
  margin-top: 16px;
  display: flex;
  align-items: center;
  width: fit-content;
  color: #92b558;
  padding: 8px 8px 8px 0;
  &:hover {
    transition-duration: 500ms;
    cursor: pointer;
    color: #4e6130;
    .text {
      text-decoration: underline;
    }
  }

  i {
    font-size: 28px;
  }
  .text {
    font-size: 20px;
    padding-left: 8px;
    font-weight: bold;
  }
}

.farm-name {
  height: 36px;
  text-align: center;
  background: #92b558;
  box-shadow: 0px 4px 4px rgb(0 0 0 / 15%);
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px 20px;
  color: white;
  font-size: 18px;
  cursor: context-menu !important;

  // @media only screen and (max-width: 875px) {
  //   font-size: 16px;
  // }
}
.overflow_hide_img {
  border-radius: 10px;
  overflow: hidden;
  width: 120px;
  height: 100px;
  position: relative;
  &_spot {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 240px;
  }
}

.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
}

.title_farm {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  h1 {
    padding: 14px 0 !important;
    margin-bottom: 0px !important;
  }
}
.con_title {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}
</style>
